<template>
    <div
      class="check"
      @click="toggleCheck"
      @keyup.space="toggleCheck"
      tabindex="0"
    >
        <i class="fas fa-check"></i>
    </div>
</template>

<script>
export default {
    methods: {
        toggleCheck () {
            this.$emit('toggleCheck')
        }
    }
}
</script>


<style scoped>
  .check {
      display: inline-block;
      border-radius: 50%;
      background-color: #D8D8D8;
      color: #ffffff;;
      width: 40px;
      height: 40px;
      line-height: 40px;
      font-size: 24px;
  }
  .check:hover {
      cursor: pointer;
  }
</style>
